import { r as registerInstance, h } from './index-e3eeb4ec.js';
import { f as ONE_DAY_IN_MS, O as ONE_MINUTE_IN_MS, e as getTimeSince } from './index-fd930a73.js';
import './index-6afae4e4.js';
const RelativeDateTime = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.clearRelativeDateTimeInterval = () => {
      clearInterval(this.relativeDateTimeInterval);
    };
    this.pubDateIsWithinOneDay = () => {
      return Math.abs(Date.now() - this.pubDate) <= ONE_DAY_IN_MS;
    };
  }
  connectedCallback() {
    this.updateTimeElapsed();
    if (this.pubDateIsWithinOneDay()) {
      this.relativeDateTimeInterval = setInterval(() => this.updateTimeElapsed(), ONE_MINUTE_IN_MS);
    }
  }
  disconnectedCallback() {
    this.clearRelativeDateTimeInterval();
  }
  updateTimeElapsed() {
    this.relativeDateTime = getTimeSince(this.pubDate, this.includeSeconds, this.isLive);
    if (this.relativeDateTimeInterval && !this.pubDateIsWithinOneDay()) {
      this.clearRelativeDateTimeInterval();
    }
  }
  render() {
    return h("span", {
      key: 'e576be09a9b5d94c4290c6acf2e083aca2af0280'
    }, this.relativeDateTime);
  }
};
export { RelativeDateTime as relative_date_time };